import Vue from 'vue';
import Cookie from 'js-cookie';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { logger, pascalCase } from '@ubeeqo/web-utils';
import { MuiAlgoliaPlugin } from '@ubeeqo/motion-ui';
import { axiosClientConfig } from '@ubeeqo/web-api-client';
import * as VueGoogleMaps from 'vue2-google-maps';
import _ from 'lodash';
import SegmentsPlugin from '../plugins/SegmentsPlugin';

const Setup = {
  async loadEnvConfig() {
    try {
      const debugDomain = Cookie.get('debugDomain') || '';
      const query = debugDomain ? `?debugDomain=${debugDomain}` : '';

      const { data } = await axios.get(`/middleware/config${query}`);
      // Desencrypt envs vars
      const bytes = CryptoJS.AES.decrypt(data.env, 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855');
      const noriginalText = bytes.toString(CryptoJS.enc.Utf8);
      const envConfig = noriginalText && JSON.parse(noriginalText);
      data.env = envConfig;
      return data;
    } catch (error) {
      logger.message('Error while loading environmental data or while encryption.', 'error');
      logger.message(error, 'error');
      return {};
    }
  },

  initAxiosClientConfig(ENV, authData = null) {
    const accessAuthData = authData || Cookie.get('authData') || localStorage.getItem('authData');
    const token = accessAuthData ? `Bearer ${JSON.parse(accessAuthData).accessToken}` : null;
    axiosClientConfig.init({
      host: ENV.apiUrl,
      token,
      source: 'clientapp',
    });
  },

  setupSegment(ENV, version) {
    const key = ENV.segment.segmentKey;

    Vue.use(
      SegmentsPlugin,
      {
        key,
        version,
      },
    );
  },

  setupAlgolia(ENV, Auth) {
    const { accessToken } = JSON.parse(_.get(Auth, 'storedAuthData', '{}'));

    Vue.use(
      MuiAlgoliaPlugin,
      {
        ...ENV.algolia,
        headers: {
          Authorization: accessToken,
        },
      },
    );
  },

  setupGoogleMaps(ENV) {
    Vue.use(VueGoogleMaps, {
      load: {
        key: ENV.googleMapsKey,
        libraries: 'places',
      },
    });
  },

  setupTitle({ title }) {
    document.title = title;
  },

  async setupTemplateLanguages(clientConfig) {
    const langs = ['en_GB', 'es_ES'];
    let langKeys = langs.map(async lang => (
      { [lang]: await import(`../../locales/${lang}.json`).then(data => data.default) }
    ));

    langKeys = await Promise.all(langKeys);
    langKeys = langKeys.reduce((a, b) => ({ ...a, ...b }), {});

    const domains = [
      'auth',
      'Billing',
      'Carsharing',
      'Motosharing',
      'RideHailing',
      'UserCompany',
    ];

    const flavor = pascalCase(clientConfig.flavor);
    langs.forEach((lang) => {
      const commonTranslations = { Common: _.get(langKeys, `${lang}.Common`, {}) };
      const domainTranslations = domains.map(domain => _.get(langKeys, `${lang}.Domain.${pascalCase(domain)}`, {}))
        .reduce((a, b) => ({ ...a, ...b }), {});
      const flavorTranslations = _.get(langKeys, `${lang}.Flavor.${flavor}`, {});

      Vue.i18n.add(
        lang,
        _.merge(
          domainTranslations,
          flavorTranslations,
          commonTranslations,
        ),
      );
    });

    Vue.i18n.set(langs[0]);
  },
};

export default Setup;
